import {
  createContext,
  MutableRefObject
} from 'react'
import { formatDateTime } from '@eventops/chronotrack-ctlive-mui'
import { createLogger } from '../../../app/logger'
import { CheckinEntry, CheckinEntryUpdate } from '../../../app/types'

// eslint-disable-next-line no-unused-vars
const logger = createLogger({
  prefix: 'ModalUtils'
})

export const athleteName = (entry?: CheckinEntry) => {
  return !entry ? '' : entry.firstName + ' ' + entry.lastName
}

export const regTime = (entry?: CheckinEntry) => {
  if (!entry?.regTransactionRegTime) {
    return ''
  }
  return `${formatDateTime(+entry.regTransactionRegTime * 1000)}`
}

export const standardProduct = (entry?: CheckinEntry) => {
  if (!entry?.standardProduct) {
    return ''
  }
  return `${entry.standardProduct.size || '(no size provided)'}`
}

export const UpdateRequestContext = createContext<MutableRefObject<CheckinEntryUpdate | undefined>>({
  current: undefined
})
